type GtagEventParams = Record<string, string | number | boolean | undefined>;

/**
 * Fire a GA4 event via window.gtag.
 * Safe to call in any client component — no-ops if gtag is not loaded.
 */
export function trackEvent(eventName: string, params?: GtagEventParams): void {
  if (
    typeof window !== 'undefined' &&
    typeof (window as Window & { gtag?: (...args: unknown[]) => void }).gtag === 'function'
  ) {
    (window as Window & { gtag: (...args: unknown[]) => void }).gtag('event', eventName, params);
  }
}
